import utils from 'utils'
import modalRetrieve from './view/modalRetrieve.html'

class retrieveCtrl {
    constructor($scope, $uibModal, httpRequest, logger, $timeout, retrieveService, querySort, initSortService) {
        $scope.totalPages = 0
        $scope.standaloneFlag = 0
        $scope.isNokeyFlag = IS_NO_KEY
        const { saleCreditCode } = JSON.parse(localStorage.user_info).sale
        const { saleId } = JSON.parse(localStorage.user_info).sale
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                invoiceType: '',
                diskCode: '',
                ukeyCode: '',
            },
        }
        $scope.reset = function () {
            $scope.queryParam.param = {
                invoiceType: '',
                diskCode: '',
                ukeyCode: '',
            }
        }
        // $scope.reset()
        httpRequest.get_getDiskBySaleId({ saleId }).then((res) => {
            $scope.diskData = res.data.value
            $scope.diskData.forEach((element) => {
                element.diskName = `${element.diskCode}号分机(${element.diskName})`
            })
            $scope.diskUkeyConfig = $scope.diskData.filter((item) => item.diskCode != 0)
            initRetrieve($scope.diskData)
            console.log($scope.diskUkeyConfig)
        })
        $scope.diskChange = function diskChange() {
            $scope.resArr = []
            // $scope.dataList = []
            const _that = this.diskSelectedModel
            console.log(_that)
            if (_that.diskCode == 0) {
                retrieveService.getDiskInfo([_that]).then((res) => {
                    $scope.diskTaxCode = res.TaxCode
                    if (!IS_NO_KEY && saleCreditCode != $scope.diskTaxCode) {
                        logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                        return
                    }
                    $scope.standaloneFlag = 1
                    $scope.diskCode = res.kpfwqh
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                    IS_NO_KEY && httpRequest.post_ukeyListByDiskCodes([$scope.diskCode]).then((res) => {
                        $scope.diskUkeyConfig = res.data.value
                    })
                    retrieveService.setDataListIfDiskCode0($scope.diskCode).then((res) => {
                        $scope.resArr = res
                        $timeout(() => {
                            const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                            $scope.dataList = (result && result.resList) || []
                            $scope.totalPages = result && result.num
                            $scope.queryParam.pageNum = result && (++result.prePage) || 1
                            if ($scope.dataList.length > 0) {
                                $scope.selectedHandle(true)
                            }
                        })
                    }, (err) => {
                        logger.logError('未检测到0号开票机，请插入后，重新刷新本页面')
                    })
                }, (error) => {
                    logger.logError(error)
                })
            } else if (_that.diskType == 2) {
                retrieveService.getDiskInfo().then((res) => {
                    $scope.diskTaxCode = res.TaxCode
                    if (!IS_NO_KEY && saleCreditCode != $scope.diskTaxCode) {
                        logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                        return
                    }
                    $scope.standaloneFlag = 1
                    $scope.diskCode = res.kpfwqh
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]

                    if (_that.diskCode != $scope.diskCode) {
                        logger.logError(`未检测到${_that.diskCode}号开票机，请插入后，重新刷新本页面`)
                    } else {
                        retrieveService.setDataListIfDiskType2().then((res) => {
                            $scope.resArr = res
                            $timeout(() => {
                                const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                                $scope.dataList = (result && result.resList) || []
                                $scope.totalPages = result && result.num
                                $scope.queryParam.pageNum = result && (++result.prePage) || 1
                                if ($scope.dataList.length > 0) {
                                    $scope.selectedHandle(true)
                                }
                            })
                        })
                    }
                }, (error) => {
                    $timeout(() => {
                        $scope.dataList = []
                    })
                    logger.logError(error)
                })
            } else if (_that.diskType == 1) {
                retrieveService.get_qryServerDiskOfPlugged(_that.diskCode).then((res) => {
                    $scope.standaloneFlag = 0
                    $scope.diskCode = res.diskCode
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                    if (!IS_NO_KEY && _that.diskCode != $scope.diskCode) {
                        logger.logError(`未检测到${_that.diskCode}号服务器，请检测网络和分盘服务器后刷新本页面`)
                    } else {
                        httpRequest.post_ukeyListByDiskCodes([_that.diskCode]).then((res) => {
                            $scope.diskUkeyConfig = res.data.value
                        })
                        $scope.resArr = res.resArr
                        const pageRes = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                        $scope.dataList = (pageRes && pageRes.resList) || []
                        $scope.totalPages = pageRes && pageRes.num
                        $scope.queryParam.pageNum = pageRes && (++pageRes.prePage) || 1
                        if ($scope.dataList.length > 0) {
                            $scope.selectedHandle(true)
                        }
                    }
                })
            }
        }
        $scope.retrieve = function retrieve(item) {
            $uibModal.open({
                template: modalRetrieve,
                controller: 'modalRetrieveCtrl',
                backdrop: 'static',
                windowClass: 'et-middleModal mod-modal-md',
                openedClass: 'mod-modal',
                resolve: {
                    items1() {
                        return {
                            obj: item,
                            diskCode: $scope.diskCode,
                            standaloneFlag: $scope.standaloneFlag,
                        }
                    },
                },
            }).result.then(() => {
                if ($scope.diskSelectedModel.diskCode == 0) {
                    initRetrieve([$scope.diskSelectedModel])
                } else if ($scope.diskSelectedModel.diskType == 2) {
                    initRetrieve()
                } else if ($scope.diskSelectedModel.diskType == 1) {
                    initRetrieve([$scope.diskSelectedModel])
                }
            })
        }
        httpRequest.get_dictByTypeArr(['stock_inv_type']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.queryList = function queryList() {
            // initRetrieve([$scope.diskSelectedModel])
            if (!$scope.resArr) return
            const data = utils.searchData($scope.resArr, [{
                type: 'invoiceType', value: $scope.queryParam.param.invoiceType,
            }, {
                type: 'diskCode', value: $scope.queryParam.param.diskCode,
            }, {
                type: 'ukeyCode',
                value: $scope.queryParam.param.ukeyCode,
            }])
            const result = utils.paging(data, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
            $timeout(() => {
                if (result) {
                    $scope.dataList = result.resList
                    $scope.totalPages = result.num
                    $scope.queryParam.pageNum = ++result.prePage
                    try {
                        $scope.selectedHandle(true)
                    } catch (e) { }
                }
            })
        }
        function initRetrieve(diskList) {
            retrieveService.getDiskInfo(diskList).then((res) => {
                $scope.diskTaxCode = res.TaxCode
                $scope.diskCode = res.kpfwqh
                $scope.standaloneFlag = setStandaloneFlag(res) // 根据有无key以及无key情况下区分条件设置standaloneFlag值
                // IS_NO_KEY && httpRequest.post_ukeyListByDiskCodes([$scope.diskCode]).then(res => {
                //     $scope.diskUkeyConfig = res.data.value;
                // })
                $timeout(() => {
                    $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                })
                console.log($scope.diskSelectedModel)
                if (!IS_NO_KEY && saleCreditCode != $scope.diskTaxCode) {
                    logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                    return
                }
                if ($scope.diskCode == 0) {
                    retrieveService.queryRetrieve($scope.diskCode).then((res) => {
                        $scope.resArr = res
                        $timeout(() => {
                            const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                            if (result) {
                                $scope.dataList = result.resList
                                $scope.totalPages = result.num
                                $scope.queryParam.pageNum = ++result.prePage
                            }
                        })
                    })
                } else {
                    retrieveService.queryInvoiceStock($scope.diskCode).then((res) => {
                        // console.log(utils.analysisXml(reg, res));
                        $scope.resArr = res
                        $timeout(() => {
                            const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                            if (result) {
                                $scope.dataList = result.resList
                                $scope.totalPages = result.num
                                $scope.queryParam.pageNum = ++result.prePage
                            }
                        })
                    })
                }
            }, (res) => {
                if (!IS_NO_KEY) {
                    retrieveService.get_qryServerDiskOfPlugged().then((res) => {
                        $scope.diskCode = res.diskCode
                        $timeout(() => {
                            $scope.diskSelectedModel = $scope.diskData.filter((item) => item.diskCode == $scope.diskCode)[0]
                        })
                        httpRequest.post_ukeyListByDiskCodes([$scope.diskCode]).then((res) => {
                            $scope.diskUkeyConfig = res.data.value
                        })
                        $scope.resArr = res.resArr
                        const result = utils.paging($scope.resArr, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
                        if (result) {
                            $scope.dataList = result.resList
                            $scope.totalPages = result.num
                            $scope.queryParam.pageNum = ++result.prePage
                        }
                    })
                } else {
                    logger.logError(res)
                }
            })
        }
        function setStandaloneFlag(obj) {
            if (!IS_NO_KEY) {
                return 1
            }
            if (obj.diskCode == 0) {
                return 1
            }
            if (obj.diskType == 2) {
                return 1
            } if (obj.diskType == 1) {
                httpRequest.post_ukeyListByDiskCodes([$scope.diskCode]).then((res) => {
                    $scope.diskUkeyConfig = res.data.value
                })
                return 0
            }
        }
        // 表头排序
        $scope.orderMap = initSortService()
        $scope.selectedHandle = function (haveData) {
            const { sortKey } = $scope.orderMap
            if (sortKey == 'nosort') return
            let list = []
            let type = 'string'
            if (sortKey == 'applyDateFormat' || sortKey == 'allotDate') {
                type = 'date'
            } else if (sortKey == 'count' || sortKey == 'collectCount' || sortKey == 'categoryCode' || sortKey == 'startNumber') {
                type = 'num'
            }
            const flag = $scope.orderMap.sortVal == 'desc' ? 1 : -1
            if (haveData) {
                list = JSON.parse(JSON.stringify($scope.dataList))
                if (!list.length) return
                if ($scope.orderMap.sortVal) {
                    list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
                }
                $scope.dataList = list
                return
            }
            if (!$scope.resArr) return
            const data = utils.searchData($scope.resArr, [{
                type: 'invoiceType', value: $scope.queryParam.param.invoiceType,
            }, {
                type: 'diskCode', value: $scope.queryParam.param.diskCode,
            }, {
                type: 'ukeyCode',
                value: $scope.queryParam.param.ukeyCode,
            }])
            const result = utils.paging(data, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
            $timeout(() => {
                if (result) {
                    list = JSON.parse(JSON.stringify(result.resList))
                    if (!list.length) return
                    // list = JSON.parse(JSON.stringify(mock))
                    if ($scope.orderMap.sortVal) {
                        list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
                    }
                    $scope.dataList = list
                }
            })
        }
    }
}

retrieveCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', 'logger', '$timeout', 'retrieveService', 'querySort', 'initSortService']
export default retrieveCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/retrieve/retrieveCtrl.js